import React from "react";
import "./Footer.css";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__top">
          {/* Brand Column */}
          <div className="footer__brand">
            <div className="footer__logo">
              <img
                src="/8 - Copy.png"
                alt="AJERA Logo"
                className="footer__logo-img"
              />
            </div>
            <p className="footer__brand-desc">
              Building tomorrow's technology today. End-to-end digital solutions
              for startups, SMBs and enterprises.
            </p>
            <div className="footer__socials">
              <a
                href="https://www.instagram.com/ajera_group?igsh=bHVycjdheXdxd2Nv"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__social footer__social--ig"
                aria-label="Follow us on Instagram"
                title="Instagram"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.057-1.645.069-4.849.069-3.205 0-3.584-.012-4.849-.069-3.259-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM5.838 12a6.162 6.162 0 1 1 12.324 0 6.162 6.162 0 0 1-12.324 0zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm4.965-10.322a1.44 1.44 0 1 1 2.881.001 1.44 1.44 0 0 1-2.881-.001z"/>
                </svg>
              </a>
              <a
                href="https://wa.me/919751772429"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__social footer__social--wa"
                aria-label="Message us on WhatsApp"
                title="WhatsApp"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.67-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.076 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421-7.403h-.004a9.87 9.87 0 00-4.953 1.226l-.36.214-3.68-.968.987 3.26-.213.341a9.915 9.915 0 .03 15.033c1.224.994 2.812 1.622 4.51 1.622 5.523 0 10-4.477 10-10s-4.477-10-10-10z"/>
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/company/ajera-group/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__social footer__social--li"
                aria-label="Connect with us on LinkedIn"
                title="LinkedIn"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.475-2.236-1.986-2.236-1.081 0-1.722.722-2.006 1.42-.103.249-.13.597-.13.946v5.439h-3.554s.05-8.736 0-9.646h3.554v1.364c.43-.664 1.195-1.609 2.905-1.609 2.121 0 3.71 1.386 3.71 4.365v5.526zM5.337 9.433c-1.144 0-1.915-.758-1.915-1.708 0-.954.77-1.708 1.957-1.708 1.188 0 1.914.754 1.939 1.708 0 .95-.751 1.708-1.981 1.708zm1.581 11.019H3.716V9.806h3.202v10.646zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.225 0z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Contact Column */}
          <div className="footer__col">
            <h4 className="footer__col-title">Contact</h4>
            <ul className="footer__links">
              <li>
                <a href="mailto:contact@ajeragroup.com">
                  contact@ajeragroup.com
                </a>
              </li>
              <li>
                <a href="tel:+919751772429">+91 9751772429</a>
              </li>
              <li className="footer__link-static">
                <span>📍 Tamil Nadu, India</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer__bottom">
          <p className="footer__copyright">
            © {currentYear} AJERA Infotech. All rights reserved.
          </p>
          <div className="footer__bottom-links">
            <a href="#privacy">Privacy Policy</a>
            <span className="footer__separator">•</span>
            <a href="#terms">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;